import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TreeNode} from 'primeng/api';
import {CommonTransformationService} from '../services/common-transformation.service';
import {ProjectDataService} from 'app/project/project/project-data-service';
import {OverlayPanel} from "primeng/overlaypanel";

@Component({
  selector: 'app-project-task-tree',
  templateUrl: './project-task-tree.component.html',
  styleUrls: ['./project-task-tree.component.css'],
  providers: [ProjectDataService]
})
export class ProjectTaskTreeComponent implements OnInit {

  @Output() handler: EventEmitter<TreeNode> = new EventEmitter();
  @Output() handlerProjectTaskTreeSize: EventEmitter<number> = new EventEmitter();

  @Input()
  set projectId(projectId: number) {
    this.projectTaskTree = [];

    if (projectId) {
      this.projectService.getTasksByProjectId(projectId).subscribe(res => {
        this.projectTaskTree = this.commonTransformationService.convertToTree('name', res['list']);
        console.log(this.projectTaskTree);
        this.handlerProjectTaskTreeSize.emit(this.projectTaskTree.length);
      });
    } else {
      this.handlerProjectTaskTreeSize.emit(0);
      this.selectedTask = null;
    }
  }

  projectTaskTree: TreeNode[] = [];
  selectedTask: TreeNode;

  constructor (private projectService: ProjectDataService, private commonTransformationService: CommonTransformationService) { }
  ngOnInit() {
    // this.projectService.getTasksByProjectId(this.projectId).subscribe(res => {
    //   this.projectTaskTree = this.commonTransformationService.convertToTree('name', res['list']);
    //   console.log(this.projectTaskTree);
    // });
  }

  onNodeSelect(event, op: OverlayPanel) {
    this.handler.emit(this.selectedTask);
    op.hide();
  }

}
